import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AddLabelToMultipleRecords from '../../components/modal/AddLabelToMultipleRecords';
import { editReceivedRecordLabels } from '../../actions/records';
import { getLabelsByPage, getLabelsByQuery } from '../../actions/labels';
import { rowSelected } from '../../actions/inboxTableActions';

class AddLabelToMultipleRecordsDialog extends Component {
  static propTypes = {
    editReceivedRecordLabels: PropTypes.func.isRequired,
  }

  render() {
    return (
      <div>
        <AddLabelToMultipleRecords
          {...this.props}
        />
      </div>
    );
  }
}

export default connect(null, {
  rowSelected,
  getLabelsByPage,
  getLabelsByQuery,
  editReceivedRecordLabels,
})(AddLabelToMultipleRecordsDialog);
